import { t } from "i18next";
import { Trans } from 'react-i18next';
import { Container, Row, Col, Accordion } from "react-bootstrap";
// import { Link } from "react-router-dom";

export default function Faq(){

    // const navigate = 

    return (
        <Container fluid as='main' className="faq">
            <Row className="skinny-row">
                <Col className="text-sm-center">
                    <h1>{t('faq.title')}</h1>
                    <p>{t('faq.body')}</p>
                </Col>
            </Row>
            <Row className="skinny-row">
                <Col>
                    <Accordion defaultActiveKey="0">
                        {[...Array(10)].map((x, i) =>
                            <Accordion.Item eventKey={i} key={i}>
                                <Accordion.Header as='div'>
                                    {t(`faq.questions.${i}.q`)}
                                </Accordion.Header>
                                <Accordion.Body>{t(`faq.questions.${i}.a`)}</Accordion.Body>
                            </Accordion.Item>
                        )}
                    </Accordion>
                    <p className="mt-5" ><Trans i18nKey={'faq.help'} components={[<a href="mailto:support@bstreet.com" />]} /></p>
                </Col>
            </Row>
        </Container>
    );
}